"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DepartmentService = void 0;
const operators_1 = require("rxjs/operators");
const restservice_1 = require("./restservice");
class DepartmentService extends restservice_1.RestService {
    constructor() {
        super(...arguments);
        this.departmentDetailsUrl = '/rest-api/account/v1/business/department/details';
        this.addDivisionURL = '/rest-api/account/v1/divison/add';
        this.addDepartmentURL = '/rest-api/account/v1/department/add';
        this.addSubDepartmentURL = '/rest-api/account/v1/subdept/add';
        this.updateDepartmentURL = '/rest-api/account/v1/department/update';
        this.transferSubURL = '/rest-api/account/v1/department/assign';
        this.updateDivisionURL = '/rest-api/account/v1/division/update';
        this.updateSubDeptURL = '/rest-api/account/v1/subDept/update';
    }
    getDepartmentDetails() {
        return this.get(this.departmentDetailsUrl).pipe(operators_1.map((data) => data));
    }
    addDivision(content) {
        return this.post(this.addDivisionURL, content, true).pipe(operators_1.map((data) => data));
    }
    addDepartment(content) {
        return this.post(this.addDepartmentURL, content, true).pipe(operators_1.map((data) => data));
    }
    addSubDepartment(content) {
        return this.post(this.addSubDepartmentURL, content, true).pipe(operators_1.map((data) => data));
    }
    updateDepartment(content) {
        return this.post(this.updateDepartmentURL, content, true).pipe(operators_1.map((data) => data));
    }
    transferSubscription(content) {
        return this.post(this.transferSubURL, content, true).pipe(operators_1.map((data) => data));
    }
    updateDivision(content) {
        return this.post(this.updateDivisionURL, content, true).pipe(operators_1.map((data) => data));
    }
    updateSubDept(content) {
        return this.post(this.updateSubDeptURL, content, true).pipe(operators_1.map((data) => data));
    }
}
exports.DepartmentService = DepartmentService;
//# sourceMappingURL=department.service.js.map